//门店数据
export default {
  StoreBasicInfo: {                                   //门店基本信息
    userArr:[],
  },                                   
                                   
  StoreRoomArr: {
    meetArr:[],
    info:{
      type_1_count:0,
      type_2_count:0,
      type_3_count:0,
      type_4_count:0,
    }
  },                                                  //门店的房间列表
  Informationtext:[],                                 //门店编辑认证信息
  StoreMeetArr: {
    meetArr:[]
  },                                                  //门店的会议室列表
  RoomMeetDetail:'',                                  //房间会议室详情
  StoreCalendar:[],                                   //门店客房日历数组
  StoreLists: {                                       //获取门店旗下所有门店
    total:0,
    lists:[]
  },
  StoreMoneyInfo: {},                                 //门店的资金信息
  StoreMoneyList:{                                    //门店资金明细、可提现列表、已提现列表、冻结金额列表
    total:0,
    money: 0,
    pay: 0,
    lists:[]
  },
  StoreBankcardList:{                                  //门店银行卡信息列表
    total:0,
    lists:[]
  },
  StoreInvoiceLists:{                                  //门店发票信息列表
    total:0,
    lists:[]
  },
  StoreDiscountLists:{                                  //门店促销信息列表
    total:0,
    lists:[]
  },
  StoreChartLists:[],                                   //门店统计报表
  StoreChartDetail:{
    total:0,
    lists:[]
  },
  discountDetail:{},                                    //某一条促销信息的详情
  ticketDetail:{},                                      //某一条门票信息的详情
  StoreTicketList:{                                     //景区门票列表
    total:0,
    lists:[]
  },
  StoreEateryList:{                                     //餐饮列表
    total:0,
    lists:[]
  },
  AdminDataLists:{                                      //管理员查看数据的列表和总数
    total:0,
    lists:[],
    info:{
    total:{},
    } 
  },
  AdminDataDetail:{},                                   //管理员查看的数据项总和
  CommentLists:{                                        //评论列表
    total:0,
    lists:[]
  },
  CommentDetail:[{}],                                   //评论详情
  CollectList:{                                         //收藏列表
    total:0,
    lists:[]
  },
  CreditList:{                                          //积分活跃明细列表
    total:0,
    lists:[]
  },
  waitVerify:{},                                        //待审核数据
  withdrawDetail:{},                                    //用户提现详情
  RebateInfo:{},                                        //用户返利信息
  BusinessList:[]
}
